import { getCartItemList } from 'clients/CartClientV2';
import { GET, getData, isValid } from 'clients/Clients';
import { KCB_PRIORITY_SELLERS, SELLER_GROUP } from 'constants/Enums';
import { PRODUCT_TAG } from 'constants/Tags';
import { convertArrayToMap } from 'utils/ArrUtils';
import { getLinkCDNImageList } from 'utils/ImageUtils';

const PRODUCT_API_PREFIX = '/marketplace/product/v1';


export function getProductSellerCode(product) {
  return product?.sellerCode || product?.sku?.sellerCode || product?.sellerInfo?.sellerCode || '';
}

export function isKcbPrioritySeller(product) {
  const sellerCode = getProductSellerCode(product);
  return !!sellerCode && KCB_PRIORITY_SELLERS.includes(sellerCode);
}

export function moveKcbPriorityFirst(products, isKcbVerified = false) {
  if (!isKcbVerified || !products?.length) return products;

  const priority = [];
  const rest = [];
  products.forEach((product) => {
    if (isKcbPrioritySeller(product)) priority.push(product);
    else rest.push(product);
  });

  if (priority.length === 0 || rest.length === 0) return products;
  return [...priority, ...rest];
}

export function getSortedProducts(products) {
  const medxNormalProducts = [];
  const medxKhuyenMaiProducts = [];
  const khuyenMaiProducts = [];
  const hoaDonNhanhProducts = [];
  const normalProducts = [];

  products?.forEach((product) => {
    if (product?.sellerCode === SELLER_GROUP.MEDX && product.tags?.includes(PRODUCT_TAG.HOADONNHANH)) {
      if (product.tags?.includes(PRODUCT_TAG.KHUYENMAI)) medxKhuyenMaiProducts.push(product);
      else medxNormalProducts.push(product);
    } else if (product.tags?.includes(PRODUCT_TAG.KHUYENMAI)) {
      khuyenMaiProducts.push(product);
    } else if (product.tags?.includes(PRODUCT_TAG.HOADONNHANH)) {
      hoaDonNhanhProducts.push(product);
    } else {
      normalProducts.push(product);
    }
  });

  return [...medxKhuyenMaiProducts, ...khuyenMaiProducts, ...medxNormalProducts, ...hoaDonNhanhProducts, ...normalProducts];
}

export const mapDataProduct = async ({ ctx, result }) => {
  let cartObject = new Map();

  // if (isValid(cartRes)) {
  //   const cart = cartRes.data[0];
  //   if (cart && !isEmpty(cart.cartItems)) {
  //     cartObject = convertArrayToMap(cart.cartItems, 'sku');
  //   }
  // }

  const cartRes = await getCartItemList({ ctx });

  if (isValid(cartRes)) {
    const cartItems = getData(cartRes);
    if (cartItems?.length > 0) {
      cartObject = convertArrayToMap(cartItems, 'sku');
    }
  }
  // eslint-disable-next-line no-param-reassign
  result.data = result.data.map((item) => ({
    ...item,
    imagesProxy: getLinkCDNImageList(item?.imageUrls) || [],
    // unit: item.unit && item.unit === '<nil>' ? '' : item.unit,
    quantity: cartObject.get(item.sku)?.quantity || 0,
  }));
  return result;
};

export const getSettingTags = async ({ ctx }) =>
  GET({
    ctx,
    url: `${PRODUCT_API_PREFIX}/tags/list`,
    isBasic: true,
  });

export default {
  mapDataProduct,
  getSettingTags,
};
